import { createContext, useContext, useEffect, useState } from "react";
import Request, { RequestResponseData } from "../../core/models/Request";
import NetworkingServiceError from "../../core/services/network/NetworkServiceError";
import appConfig from "../../util/appConfig";

// This context allows the app to get the Requests information

export type RequestError = NetworkingServiceError;

// Create type
export type RequestsDataType = {
  requestsResponseData?: RequestResponseData;
  setRequestsResponseData: (responseData?: RequestResponseData) => void;
  selectedRequest?: Request;
  setSelectedRequest: (request?: Request) => void;
  requestLoading: boolean;
  setRequestLoading: (isLoading: boolean) => void;
  requestsError: RequestError | undefined;
  setRequestsError: (error?: RequestError) => void;
  saveRequestDetailsTrigger: number;
  setSaveRequestDetailsTrigger: (value: number) => void;
};

// Create context for type
// @ts-ignore
export const RequestsDataContext = createContext<RequestsDataType>();

//Create provider of the context
export const RequestsDataProvider = ({ children }: any) => {
  const [selectedRequest, setSelectedRequest] = useState<Request>();
  const [requestsResponseData, setRequestsResponseData] =
    useState<RequestResponseData>();
  const [requestLoading, setRequestLoading] = useState<boolean>(false);
  const [requestsError, setRequestsError] = useState<RequestError>();
  const [saveRequestDetailsTrigger, setSaveRequestDetailsTrigger] = useState(0);

  const value = {
    requestsResponseData,
    setRequestsResponseData,
    selectedRequest,
    setSelectedRequest,
    requestLoading,
    setRequestLoading,
    requestsError,
    setRequestsError,
    saveRequestDetailsTrigger,
    setSaveRequestDetailsTrigger,
  };
  useEffect(() => {
    if (appConfig.debugRequests && selectedRequest)
      console.debug("[Requests][SelectedRequest] ", selectedRequest);
  }, [selectedRequest]);

  useEffect(() => {
    if (appConfig.debugRequests && saveRequestDetailsTrigger)
      console.debug(
        "[Requests][saveRequestDetailsTrigger] ",
        saveRequestDetailsTrigger
      );
  }, [saveRequestDetailsTrigger]);

  useEffect(() => {
    if (appConfig.debugRequests && requestsResponseData)
      console.debug("[Requests][RequestsResponseData] ", requestsResponseData);
  }, [requestsResponseData]);

  useEffect(() => {
    if (appConfig.debugRequests && requestLoading)
      console.debug("[Requests][RequestLoading] ", requestLoading);
  }, [requestLoading]);

  useEffect(() => {
    if (appConfig.debugRequests && requestsError)
      console.warn(
        "[Requests][Error] ",
        requestsError?.userMessage(),
        requestsError?.debugMessage()
      );
  }, [requestsError]);
  return (
    <RequestsDataContext.Provider value={value}>
      {children}
    </RequestsDataContext.Provider>
  );
};

export const useRequestsContext = () => useContext(RequestsDataContext);
